export class Interpritate {
    constructor(gudhub) {
        this.gudhub = gudhub;
    }

    /*********************** GET INTERPRETATION OBJ ***********************/
    // In this method we are looking for interpretation in data model according to interpretation src
    // then we merged with default interpretation from defaultFieldDataModel
    // if there are no current interpretation we use default interpretation
    async getInterpretationObj(fieldDataModel, defaultFieldDataModel, src, containerId, itemId, appId) {
        var currentIntrpr = [];
        // Creating default interpretation
        var defaultIntrprObj = defaultFieldDataModel.data_model.interpretation.find(function (interpritation) {
            return interpritation.src == src;
        }) || defaultFieldDataModel.data_model.interpretation.find(function (interpritation) {
            return interpritation.src == 'table';
        }) || { id: 'default' };

        var interpretation = defaultIntrprObj;

        if (fieldDataModel.data_model && fieldDataModel.data_model.interpretation) {
            // To detect interpretation we use (container_id), if there is not (container_id) we use (src)
            for(var i = 0; i < fieldDataModel.data_model.interpretation.length; i++) {
                if(fieldDataModel.data_model.interpretation[i].src == src || fieldDataModel.data_model.interpretation[i].src == containerId) {
                    currentIntrpr.push(fieldDataModel.data_model.interpretation[i]);
                }
            }

            for(var i = 0; i < currentIntrpr.length; i++) {
                if(currentIntrpr[i].settings && currentIntrpr[i].settings.condition_filter && currentIntrpr[i].settings.filters_list.length > 0) {
                    const item = await gudhub.getItem(appId, itemId);
                    if(item) {
                        const filteredItems = gudhub.filter([item], currentIntrpr[i].settings.filters_list);
                        if(filteredItems.length > 0) {
                            interpretation = currentIntrpr[i];
                            break;
                        }
                    }
                } else {
                    interpretation = gudhub.mergeObjects(interpretation, currentIntrpr[i]);
                }
            }

        }
        
        return interpretation;
    }

    /*********************** GET INTERPRETATION ***********************/

    getInterpretation(value, field, dataType, source, itemId, appId, containerId) {
        const self = this;
        return new Promise(async (resolve, reject) => {
            /*-- By default we use 'data_type' from field but in case if field is undefined we use 'dataType' from attribute*/
            var data_type = field && field.data_type ? field.data_type : dataType;

            /*---- Constructing Data Object ----*/
            if (data_type) {
                /*-- if we have data_type then we construct new data object to interpritate value*/
                gudhub.ghconstructor.getInstance(data_type).then(async function (data) {
                    if(data) {
                        var interpretationObj = await self.getInterpretationObj(field, data.getTemplate().model, source, containerId, itemId, appId);
                        data.getInterpretation(value, interpretationObj.id, data_type, field, itemId, appId).then(function (result) {
                            // console.log(result, interpretationObj)

                            resolve(gudhub.mergeObjects(result, interpretationObj));
                        }, function (error) {
                            reject();
                        });
                    }
                }, function (error) { });

            } else {
                console.error('Get Interpretation: data_type is undefined', dataType, field);
            }
        });
    }

    /********************* GET INTERPRETATION BY ID *********************/

    // We add ability to pass value as argument, to reduce number of operations in this case (getFieldValue)
    // This helps if you call method many times, for example in calculator sum and you already have field value
    // By default, value is null, to not break old code working with this method

    // For field same as above for value
    async getInterpretationById(appId, itemId, fieldId, interpretationId, value = null, field = null) {
        let fieldValue = value == null ? await this.gudhub.getFieldValue(appId, itemId, fieldId) : value;
        let fieldModel = field == null ? await this.gudhub.getField(appId, fieldId) : field;
        if(fieldModel == null) {
            return '';
        }

        const instance = await this.gudhub.ghconstructor.getInstance(fieldModel.data_type);
        const interpretatedValue = await instance.getInterpretation(fieldValue, interpretationId, fieldModel.data_type, fieldModel, itemId, appId);
        if(interpretatedValue.html == '<span>no interpretation</span>') {
            return fieldValue;
        } else {
            return interpretatedValue.html;
        }
    }

}